module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "do-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v("Deaktiver puljer")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('div', {
    staticClass: "d-explainer-box text-explainer text-explainer__error"
  }, [_c('svg', {
    staticClass: "tw-icon icon-help",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
    }
  })]), _vm._v("\n        Deaktiver puljer for Undervisning, Øvrige opgaver m.m., så systemet i stedet beregner en samlet pulje baseret på det samlede antal timer allokeret på brikker.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setDeactivatePoolsActive.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label color-dark"
  }, [_vm._v("Deaktiver puljer")]), _vm._v(" "), _c('div', {
    staticClass: "do-switch",
    class: {
      'do-switch--active': _vm.isDeactivatePoolsActive
    }
  })]), _vm._v(" "), (_vm.canConfigureAssignedPoolNormWhenPoolsDeactivated && _vm.isDeactivatePoolsActive) ? [_c('div', {
    staticClass: "d-explainer-box text-explainer marg-1-top"
  }, [_c('svg', {
    staticClass: "tw-icon icon-help",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
    }
  })]), _vm._v("\n          Brug puljen fra " + _vm._s(_vm.localPoolTitle) + " i stedet for summen af " + _vm._s(_vm.localPoolTitle) + "-brikker i sammentællingen.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setAssignedPoolFromNormActive.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label color-dark"
  }, [_vm._v(_vm._s(_vm.localPoolTitle) + " fra årsnorm")]), _vm._v(" "), _c('div', {
    staticClass: "do-switch",
    class: {
      'do-switch--active': _vm.isAssignedPoolFromNormActive
    }
  })])] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31d3b1d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursDeactivatePoolsModal.vue
// module id = 1843
// module chunks = 1